var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBack = function SvgBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "13px",
    viewBox: "0 0 16 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-440.000000, -381.000000)",
    fill: "#1DBADF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(440.000000, 380.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.69928438,4.89272612 L3.69928438,12.9064097 C3.69928438,14.1009516 4.66492495,15.0632283 5.85610297,15.0632283 L11.7799531,15.0632283 C12.974495,15.0632283 13.9367717,14.0975878 13.9367717,12.9064097 L13.9367717,3.22004693 C13.9367717,2.02550503 12.4292643,3.13443209 12.4292643,3.732784 L12.4844406,12.5066482 C12.4844406,13.1044808 12.002897,13.5865438 11.4045451,13.5865438 L6.38336691,13.5512039 C5.78553434,13.5512039 5.30347139,13.0696603 5.30347139,12.4713084 L5.30347139,4.89272612 C5.30347139,4.44974211 4.94436189,4.09063262 4.50137788,4.09063262 L4.50137788,4.09063262 C4.05839387,4.09063262 3.69928438,4.44974211 3.69928438,4.89272612 Z",
    id: "Combined-Shape",
    fillRule: "nonzero",
    transform: "translate(8.818028, 8.875946) rotate(-90.000000) translate(-8.818028, -8.875946) "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    transform: "translate(2.500000, 4.500000) rotate(-90.000000) translate(-2.500000, -4.500000) ",
    points: "2.47064209 2 5.5 7 -0.5 7"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back.3268dfed.svg";
export { ForwardRef as ReactComponent };